export default __webpack_public_path__ + "static/media/hospital-1.e51d5730.png";